import { render, staticRenderFns } from "./SVGFolder.vue?vue&type=template&id=1f9c7136&scoped=true&"
import script from "./SVGFolder.vue?vue&type=script&lang=js&"
export * from "./SVGFolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9c7136",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f9c7136')) {
      api.createRecord('1f9c7136', component.options)
    } else {
      api.reload('1f9c7136', component.options)
    }
    module.hot.accept("./SVGFolder.vue?vue&type=template&id=1f9c7136&scoped=true&", function () {
      api.rerender('1f9c7136', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/SVG/SVGFolder.vue"
export default component.exports